export default __webpack_public_path__ + "static/media/Zahl-7.4d3a3a20.webp";